import React from 'react';
import { useLang } from "../../../contexts/LanguageContext";
import { AmbientSelector } from '../../player/AmbientSelector';
import ambient_sound from '../../../images/ambient-sound.svg';

export const AmbientSettings = ({ preferences, onChange }) => {
  const { t } = useLang();

  return (
    <>
      <label className="settings-label"><img src={ambient_sound} className="settingsLabelIcon" alt="Ambient Icon" />{t("AMBIENT_TITLE")}</label>
      <AmbientSelector 
        preferences={preferences} 
        onChange={onChange} 
      />
    </>
  );
};
